import React from 'react';
import { WarningBarDiv } from './WarningBar.styles';

interface WarningBarProps {
	show: boolean;
	message: string;
}

export const WarningBar = ({ show, message }: WarningBarProps) => {
	if (show) {
		return <WarningBarDiv>{message}</WarningBarDiv>;
	}
	return <></>;
};
